const path = import.meta.env.VITE_API_URL || 'http://openwebinars.net';

export class api {

  static async post(url, data) {
    if (!url.startsWith('http')) {
      url = `${path}${url}`;
    } else if (url.startsWith('undefined')) {
      url = url.replace('undefined', path);
    }
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return await response.json();
  }

  static async get(url) {
    if (!url.startsWith('http')) {
      url = `${path}${url}`;
    } else if (url.startsWith('undefined')) {
      url = url.replace('undefined', path);
    }
    const response = await fetch(url);
    return await response.json();
  }
}